import SearchParamsBase from '../../../Elements/SearchParamsBase';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import TpPlatformInvoiceCostTypesEnum, {
  TpPlatformInvoiceCostTypeLabels,
} from '../../../Enums/TpPlatformInvoiceCostTypesEnum';

export default class TpPlatformInvoiceItemSearchParams extends SearchParamsBase {
  initialize() {
    // Preset by TpPlatformInvoiceItemsTab; the backend filters items to this invoice
    // (and, on the typed popup tabs, to one cost type). Both are SCOPE, not user filters.
    this.TpPlatformInvoiceId = '';
    this.CostType = '';
    // User filters.
    this.SelectedOfficeIds = [];
    this.SelectedCaspianClientIds = [];
    this.FilterCostType = '';
    this.BillingCode = '';
  }

  ClearAll() {
    // Deliberately keeps TpPlatformInvoiceId — the embedded grid is always scoped to one invoice.
  }

  static fieldsInSearchBox = [
    {
      fieldName: 'SelectedOfficeIds',
      label: 'Office',
      className: 'col-6',
      type: InputTypesEnum.OfficeOrGroupMultiSelect,
    },
    {
      fieldName: 'SelectedCaspianClientIds',
      label: 'Caspian Client',
      className: 'col-6',
      type: InputTypesEnum.ClientMultiChoice,
    },
    {
      // A SEPARATE property from the CostType scope field on purpose. Reusing CostType would make
      // this descriptor hide itself the moment the user picked a value; `hide` reads only the scope
      // field, which users never write — so the filter shows on the All tab and self-hides on the
      // typed sub-tabs, which already narrow to one type. It is the ONLY way to reach Recording,
      // CommentCard, Audit, Text and VirtualNumber, none of which has a sub-tab.
      fieldName: 'FilterCostType',
      label: 'Cost Type',
      className: 'col-6',
      type: InputTypesEnum.Select,
      options: TpPlatformInvoiceItemSearchParams.getCostTypeOptions(),
      hide: (searchItem) => !!searchItem.CostType,
    },
    {
      fieldName: 'BillingCode',
      label: 'Billing Code',
      className: 'col-6',
      type: InputTypesEnum.Text,
    },
  ];

  static title = 'Search in Invoice Items';
  static iconName = 'fa-solid fa-search';
  static saveType = 'TpPlatformInvoiceItemSearchParams';

  static isThereAnySearchParameter() {
    return false;
  }

  static getCostTypeOptions() {
    return [
      { label: 'Choose one...', value: '', disabled: false },
      ...Object.values(TpPlatformInvoiceCostTypesEnum).map((costType) => ({
        label: TpPlatformInvoiceCostTypeLabels[costType],
        value: costType,
        disabled: false,
      })),
    ];
  }
}
